var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.jwt)?_c('div',[_vm._v("Please login or sign up")]):_c('div',{staticStyle:{"display":"flex"}},[_c('SearchBox'),_c('SavedSearches')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }